import React from "react"

import PropTypes from "prop-types"

import "./style.scss"

export const TYPOGRAPHY_VARIANTS = {
    H1: "h1",
    H2: "h2",
    H3: "h3",
    H4: "h4",
    PARAGRAPH: "p",
    SPAN: "span",
}

const Typography = ({
    as: Component = TYPOGRAPHY_VARIANTS.PARAGRAPH,
    variant,
    className,
    children,
    ...props
}) => (
    <Component
        className={`typography variant-${variant ? variant : Component}${className ? ` ${className}` : ""}`}
        {...props}
    >
        {children}
    </Component>
)

Typography.propTypes = {
    as: PropTypes.oneOf(Object.values(TYPOGRAPHY_VARIANTS)),
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    variant: PropTypes.oneOf(Object.values(TYPOGRAPHY_VARIANTS)),
}

export default Typography
